/* eslint-disable no-nested-ternary */
import { FunctionComponent, useContext } from 'react'
import Select, { Options, StylesConfig, components } from 'react-select'
import styled, { ThemeContext } from 'styled-components'

import { CustomSelectInputStyle } from 'components/GlobalStyles/Inputs/types'
import { getCustomStyles } from 'components/GlobalStyles/Inputs/utils'
import { DownChevron } from 'components/SVG/Chevron'
import { DownFilledArrow } from 'components/SVG/filledArrows'

interface IOpenProps {
  open?: boolean
  custom?: boolean
}
const ArrowContainer = styled.div<IOpenProps>`
  display: flex;
  height: 12px;
  width: 12px;
  justify-content: center;
  align-items: center;
  ${props => props.open && 'transform: rotate(180deg);'}
  transition: all 0.25s ease-in-out;
`

export type IOption = Record<string, any>
export interface ISelectInputProps {
  defaultValue?: IOption
  name?: string
  value?: IOption | null | undefined
  id?: string
  inputId?: string
  isSearchable?: boolean
  options: Options<IOption>
  placeholder?: string
  custom?: boolean
  disabled?: boolean
  requiredMissingField?: boolean
  backgroundColor?: string
  customSelectInputStyle?: CustomSelectInputStyle
  ariaLabel?: string
  error?: boolean
  stylesConfig?: StylesConfig<any, boolean>
  dropdownIcon?: JSX.Element
  onChange(v: any): void
}

const SelectInput: FunctionComponent<ISelectInputProps> = ({
  defaultValue,
  value,
  name,
  id,
  inputId,
  isSearchable = false,
  options,
  placeholder,
  custom,
  disabled,
  requiredMissingField,
  backgroundColor,
  customSelectInputStyle,
  ariaLabel,
  error,
  stylesConfig,
  dropdownIcon,
  onChange,
}) => {
  const theme = useContext(ThemeContext)

  const customStyles
    = stylesConfig
    || getCustomStyles(
      theme,
      custom,
      requiredMissingField,
      backgroundColor,
      error,
      customSelectInputStyle,
    )

  // @FIXME - not sure if it's possible to avoid this using react-selects prop API
  // eslint-disable-next-line react/no-unstable-nested-components
  const DropdownIndicator = (props: any) => {
    const DownArrowIcon = custom ? DownChevron : DownFilledArrow

    return (
      <components.DropdownIndicator {...props}>
        <ArrowContainer
          open={props.selectProps.menuIsOpen}
          custom={custom}
        >
          {dropdownIcon || (
            <DownArrowIcon
              width={10}
              height={6}
              fill="black"
            />
          )}
        </ArrowContainer>
      </components.DropdownIndicator>
    )
  }

  return (
    <div data-testid={name}>
      <Select
        instanceId={id || 'select-input'}
        id={id}
        options={options}
        onChange={onChange}
        placeholder={placeholder || 'Choose One...'}
        styles={customStyles}
        components={{ DropdownIndicator }}
        defaultValue={defaultValue}
        isDisabled={disabled}
        isSearchable={isSearchable}
        value={value}
        inputId={inputId}
        aria-label={ariaLabel}
        /* Default placement of the menu in relation to the control. 'auto' will flip
           when there isn't enough space below the control. */
        menuPlacement="auto"
      />
    </div>
  )
}

export default SelectInput
